import { JSX } from 'solid-js';
import { TrimbleLogo } from './TrimbleLogo';
import { NavbarActions } from './NavbarActions';
import { UserMenu } from './UserMenu';
import { ProjectMenu } from '@trimble/connect-project-ui';

interface TrimblePageHeaderProps {
  appName: string;
  projectExplorerUrl?: string;
  profileUrl: string;
  helpUrl?: string;
}

export const TrimblePageHeader = (
  props: TrimblePageHeaderProps
): JSX.Element => {
  return (
    <>
      <div
        class="h-[64px] relative bg-[var(--modus-navbar-bg)] flex justify-between items-center px-4 border-b border-gray-1 z-header"
        data-testid="main-navbar"
      >
        <div class="flex items-center gap-3" data-testid="navbar-left">
          <div data-testid="trimble-logo">
            <TrimbleLogo />
          </div>
          <span class="text-sm font-medium leading-none" data-testid="app-name">
            {props.appName}
          </span>
          <div class="w-px h-8 bg-gray-3" />
          <ProjectMenu projectExplorerUrl={props.projectExplorerUrl} />
        </div>

        <div class="flex items-center gap-5" data-testid="navbar-right">
          <NavbarActions helpUrl={props.helpUrl} />
          <UserMenu profileUrl={props.profileUrl} />
        </div>
      </div>
    </>
  );
};
